import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const PreResultHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="pre_result" t={t}>
      <Box mb={3}>
        <H3>Ergebnis des Schnellchecks</H3>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Im Schnellcheck konnten wir keine rechtlichen, kalkulatorischen oder materiellen Feinheiten Ihrer Abrechnung
          analysieren. Eine seriöse Prüfung Ihrer Nebenkostenabrechnung benötigt die Sichtung aller Unterlagen inklusive
          Ihrem Mietvertrag. Das angezeigte Ergebnis basiert auf der Grundlage der bisher geprüften Abrechnungen und
          dient nicht als Garantie für zukünftige Prüfungen.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Nutzen Sie dafür die Mineko Expertenprüfung und laden Sie online die Unterlagen zur Prüfung hoch.
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default PreResultHelp;
